import React, { useState } from 'react';

const SCORE_CONFIG = {
  nao_abriu: { bg: 'transparent', border: '#cbd5e1', label: 'Não abriu' },
  frio:      { bg: '#94a3b8',     border: '#94a3b8', label: 'Frio' },
  morno:     { bg: '#eab308',     border: '#eab308', label: 'Morno' },
  quente:    { bg: '#22c55e',     border: '#22c55e', label: 'Quente' }
};

function formatTime(s) {
  if (!s) return '0s';
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  return s % 60 > 0 ? `${m}m ${s % 60}s` : `${m}m`;
}

export default function EngagementDot({ engagement }) {
  const [show, setShow] = useState(false);
  const score = engagement?.engagement_score || 'nao_abriu';
  const c = SCORE_CONFIG[score] || SCORE_CONFIG.nao_abriu;
  const visits = engagement?.total_visits || 0;
  const time = engagement?.total_time_seconds || 0;
  const last = engagement?.last_opened_at;

  return (
    <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}
      onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)}>
      <div style={{
        width: '10px', height: '10px', borderRadius: '50%',
        backgroundColor: c.bg, border: `2px solid ${c.border}`,
        flexShrink: 0, transition: 'all 0.3s ease'
      }} />
      {show && (
        <div style={{
          position: 'absolute', left: '20px', top: '50%', transform: 'translateY(-50%)',
          backgroundColor: '#1e293b', color: '#f1f5f9', padding: '0.5rem 0.75rem',
          borderRadius: '8px', fontSize: '0.75rem', whiteSpace: 'nowrap', zIndex: 50,
          boxShadow: '0 4px 12px rgba(0,0,0,0.2)', lineHeight: 1.5
        }}>
          <div style={{ fontWeight: 600, marginBottom: '2px' }}>{c.label}</div>
          {visits > 0 ? (
            <>
              <div>{visits} visita{visits > 1 ? 's' : ''} · {formatTime(time)} total</div>
              {last && <div style={{ color: '#94a3b8', fontSize: '0.7rem' }}>
                Último: {new Date(last).toLocaleDateString('pt-BR')} {new Date(last).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
              </div>}
            </>
          ) : (
            <div style={{ color: '#94a3b8' }}>Nenhum acesso</div>
          )}
          <div style={{
            position: 'absolute', left: '-4px', top: '50%',
            transform: 'translateY(-50%) rotate(45deg)',
            width: '8px', height: '8px', backgroundColor: '#1e293b'
          }} />
        </div>
      )}
    </div>
  );
}
